module.exports = __webpack_public_path__ + "static/media/landing-bg.958634d7.png";